import { render, staticRenderFns } from "./DeleteChange.vue?vue&type=template&id=26fcf008"
import script from "./DeleteChange.vue?vue&type=script&lang=js"
export * from "./DeleteChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports